import * as React from 'react';

import { BadgesList } from '../../components/BadgesList';
import styled from 'styled-components';
import { getUserBadges } from './selectors';
import { useSelector } from 'react-redux';
import { allBadges } from './AllBadges/allBadges';

const BadgesScrollContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  overflow-y: scroll;
  max-width: 100vw;
  max-height: calc(100vh - ${p => p.theme.sizes.headerHeight} - ${p => p.theme.sizes.headerHeight});
`;

const Container = styled.div`
  padding-top: 2em;
  max-width: 540px;
`;

const UserBadgesContainer = () => {
  const unlockedBadges = useSelector(getUserBadges);
  const badges = allBadges;
  return (
    <BadgesScrollContainer>
      <Container>
        <BadgesList allBadges={badges} unlockedBadgesIds={unlockedBadges} />
      </Container>
    </BadgesScrollContainer>
  );
};

export default React.memo(UserBadgesContainer);



// WEBPACK FOOTER //
// ./src/containers/Badges/index.tsx